import { useSelector } from 'react-redux';
import { RootState } from '../store';
import NotificationBell from './NotificationBell';
import EnablePushChip from './EnablePushChip';
import SettingsCog from './SettingsCog';
import classes from './TopBarActions.module.scss';

const TopBarActions = () => {
  const isAuthenticated = useSelector((s: RootState) => s.auth.isAuthenticated);
  if (!isAuthenticated) return null;
  return (
    <div className={classes.bar}>
      <EnablePushChip />
      <NotificationBell />
      <SettingsCog />
    </div>
  );
};

export default TopBarActions;
